export const convertToTitleCase = (string) => {
  return string.replace(/-/g, ' ').toLowerCase().replace(/(?:^|[\s-/])\w/g, (match) => match.toUpperCase());
};